import ClientStatementOfAccount from "../components/ClientStatementOfAccount/ClientStatementOfAccount";

export default function ClientStatementOfAccountPage() {
    return <ClientStatementOfAccount />;
}
